module.exports = __webpack_public_path__ + "static/media/woman.e626870e.png";